import { motion } from "framer-motion";
import { 
  Target, 
  Clock, 
  Settings, 
  Play,
  Check,
  Rocket
} from "lucide-react";

const steps = [
  {
    icon: Target,
    number: "01",
    title: "Defina sua meta mensal",
    description: "Quanto você quer faturar por mês? O sistema calcula tudo a partir disso.",
  },
  {
    icon: Clock,
    number: "02",
    title: "Informe seu valor hora",
    description: "Ou deixe o calculador sugerir com base na sua meta e horas disponíveis.",
  },
  {
    icon: Settings,
    number: "03",
    title: "Ajuste seu regime",
    description: "MEI, Simples, PJ... o sistema considera impostos na sua projeção.",
  },
  {
    icon: Play,
    number: "04",
    title: "Comece a registrar",
    description: "Inicie o timer e veja seu faturamento crescer em tempo real.",
  },
];

export function OnboardingSection() {
  return (
    <section className="relative py-20 sm:py-28 bg-gradient-to-b from-muted/30 to-background overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" />
      </div>

      <div className="container relative mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium mb-6">
            <Rocket className="h-4 w-4" />
            Simples de começar
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-wide text-foreground mb-4">
            CONFIGURE EM{" "}
            <span className="text-primary">
              MENOS DE 3 MINUTOS
            </span>
          </h2>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Connection line */}
            <div className="absolute left-8 top-0 bottom-0 w-px bg-gradient-to-b from-primary/50 via-primary/20 to-transparent hidden sm:block" />

            <div className="space-y-6">
              {steps.map((step, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="relative flex items-start gap-6"
                >
                  {/* Step indicator */}
                  <div className="relative z-10 flex-shrink-0">
                    <div className="w-16 h-16 rounded-2xl bg-primary flex items-center justify-center shadow-lg shadow-primary/25">
                      <step.icon className="h-7 w-7 text-primary-foreground" />
                    </div>
                    {index < steps.length - 1 && (
                      <div className="absolute top-16 left-1/2 -translate-x-1/2 w-px h-6 bg-primary/30 sm:hidden" />
                    )}
                  </div>

                  {/* Content */}
                  <div className="flex-1 pt-2">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-primary font-mono text-sm">{step.number}</span>
                      <h3 className="text-xl font-bold text-foreground">{step.title}</h3>
                    </div>
                    <p className="text-muted-foreground leading-relaxed">{step.description}</p>
                  </div>

                  {/* Check mark */}
                  <div className="hidden sm:flex w-10 h-10 rounded-full bg-primary/10 items-center justify-center flex-shrink-0 mt-2">
                    <Check className="h-5 w-5 text-primary" />
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
